module.exports = __webpack_public_path__ + "img/06.e53e4849.png";